import { render, staticRenderFns } from "./cadastroVeiculo.vue?vue&type=template&id=4b39dec0&scoped=true"
import script from "./cadastroVeiculo.vue?vue&type=script&lang=js"
export * from "./cadastroVeiculo.vue?vue&type=script&lang=js"
import style0 from "./cadastroVeiculo.vue?vue&type=style&index=0&id=4b39dec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39dec0",
  null
  
)

export default component.exports